import React  from 'react';
import bitmap from 'img/Bitmap.png';
import './styles.scss';

export default () => (
  <div className="content">
    <div className="description">
      <h1 className="description__title"> Welcome to <span className="strong">contact.center</span><sup>TM</sup></h1>

      <div className="description__text">
        <p>
          <b>Organize</b> and access your business contacts in an easier and safer manner.
        </p>
        <p>
          <b>Enrich</b> your contact information and enhance your business intelligence.
        </p>
        <p>
          <b>Integrate</b> with AI-based bots to automate your business communications.
        </p>
        <p>And more.</p>
      </div>
      <div className="description__logo">
        <img src={ bitmap } alt="contact.center" />
      </div>
      <div className="coming-soon">Coming soon...</div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/index.js